export const SERVICES = [
  { slug: "event-management", imgs: ["/assets/proj-ilink.jpg"] },
  { slug: "corporate-event", imgs: ["/assets/team-ballroom.jpg", "/assets/event-coffee.jpg"] },
  { slug: "brand-activation", imgs: [] },
  { slug: "event-gathering", imgs: ["/assets/proj-evonik.jpg", "/assets/gal-evonik-gala.jpg", "/assets/gal-evonik-kecak.jpg"] },
  { slug: "community-event", imgs: [] },
  { slug: "campus-event", imgs: [] },
  { slug: "launching-event", imgs: [] },
];
